<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="isMobileBreakpoint"
    :width="isMobileBreakpoint ? '' : '960px'"
    content-class="dialogStyle"
    transition="scale-transition"
    :scrollable="isMobileBreakpoint"
    z-index="700"
    @click:outside="closeDialog"
    @keydown.esc="closeDialog"
  >
    <v-card
      :class="{ 'd-flex': !isMobileBreakpoint }"
      :ripple="false"
      :style="{
        height: isMobileBreakpoint ? '' : '500px',
        'border-radius': isMobileBreakpoint ? '' : '27px',
      }"
    >
      <!-- Background and Image Game -->
      <div
        class="backgroundImageOverlay"
        :style="{
          'background-image': backgroundGame,
          'background-position': 'center',
          'background-size': 'cover',
          width: isMobileBreakpoint ? '' : '50%',
          'min-height': isMobileBreakpoint ? '40vh' : '100%',
          'overflow-y': isMobileBreakpoint ? 'hidden' : '',
          'border-radius': isMobileBreakpoint ? '' : '16px 0 0 16px',
        }"
      >
        <!-- Close dialog mobile button -->
        <div
          v-if="isMobileBreakpoint"
          style="position: absolute; top: 8px; right: 8px;"
        >
          <v-spacer />
          <v-btn icon @click="closeDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <!-- Image Game -->
        <div class="d-flex justify-center align-center" style="height: 100%;">
          <v-img
            v-if="imageError === false"
            :src="item.src"
            eager
            max-width="60%"
            @error="imageError = true"
            style="
                border-radius: 2rem;
                -webkit-box-shadow: 10px 10px 20px 5px #000000;
                box-shadow: 0px 32px 40px 1px rgba(0, 0, 0, 0.5);
              "
            :style="isMobileBreakpoint && 'margin: 20vw 0;'"
          >
            <template v-slot:placeholder>
              <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                  color="grey-lighten-4"
                  indeterminate
                ></v-progress-circular>
              </div>
            </template>
          </v-img>
          <div
            v-else
            class="d-flex justify-center imageErrorIcon"
            :alt="type === 'providers' ? item.name : item.title_game"
            :class="{ 'px-4': type === 'providers' }"
            style="min-height: 160px; max-height: 150px;"
          >
            <v-icon color="primary">mdi-poker-chip</v-icon>
          </div>
        </div>
      </div>

      <!-- Close dialog button / Content / Play button -->
      <div
        :style="{
          width: isMobileBreakpoint ? '' : '50%',
          'overflow-y': isMobileBreakpoint ? 'auto' : '',
        }"
      >
        <!-- Close dialog desktop button -->
        <div
          v-if="!isMobileBreakpoint"
          class="d-flex align-center px-6"
          style="height: 64px;"
        >
          <!-- Title Game Desktop -->
          <div v-if="!isMobileBreakpoint" class="text-h5 text-truncate">
            {{ item.title_game }}
          </div>
          <v-spacer />
          <v-btn icon @click="closeDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <!-- Content -->
        <div
          class="mx-auto px-6 d-flex flex-column"
          style="height: calc(100% - 86px);"
        >
          <!-- Title Game Mobile -->
          <div v-if="isMobileBreakpoint" class="text-h5 mt-6">
            {{ item.title_game }}
          </div>
          <!-- Provider Image / Volatility / RTP -->
          <div
            class="d-flex justify-space-between align-center"
            :class="isMobileBreakpoint ? 'mt-6 mb-4' : 'my-4'"
            style="width: 100%;"
          >
            <v-row>
              <!-- Provider Image -->
              <v-col>
                <div
                  class="d-flex align-center"
                  @click="allGamesProvider(item.id_provider)"
                  style="height: 100%; cursor: pointer;"
                >
                  <img width="90px" :src="item.providerImage" />
                </div>
              </v-col>
              <!-- RTP -->
              <v-col>
                <div
                  v-if="rtpValue > 0"
                  class="d-flex flex-column align-center"
                >
                  <!-- RTP Name and Tooltip-->
                  <div class="d-flex align-center mb-1" style="gap: 5px;">
                    <div class="item-info">
                      RTP
                    </div>
                    <div>
                      <v-tooltip
                        bottom
                        :nudge-right="116"
                        content-class="tooltip__content--rtp mt-1"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            color="#d9d9d9"
                            v-bind="attrs"
                            v-on="on"
                            style="cursor: pointer;"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div class="tooltip">
                          {{ $t("newCasino.rtp.tooltip") }}
                        </div>
                      </v-tooltip>
                    </div>
                  </div>
                  <!-- RTP Value -->
                  <div class="item-info-value">{{ rtpValue }}%</div>
                </div>
              </v-col>
              <!-- Volatility -->
              <v-col>
                <div v-if="volatilityText" class="d-flex flex-column">
                  <!-- Volatility Name and Tooltip-->
                  <div class="d-flex align-center mb-1" style="gap: 5px;">
                    <div class="item-info">
                      {{ $t("newCasino.volatility.name") }}
                    </div>
                    <div>
                      <v-tooltip
                        bottom
                        :nudge-left="25"
                        content-class="tooltip__content--volatility mt-1"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            color="#d9d9d9"
                            v-bind="attrs"
                            v-on="on"
                            style="cursor: pointer;"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div class="tooltip">
                          {{ $t("newCasino.volatility.tooltip") }}
                        </div>
                      </v-tooltip>
                    </div>
                  </div>
                  <!-- Volatility Text -->
                  <div class="item-info-value" :class="volatilityColor">
                    {{ volatilityText }}
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
          <!-- Categories Game -->
          <div
            class="d-flex align-center flex-wrap"
            style="overflow: hidden;"
            :style="{ order: 1, 'min-height': '56px', 'max-height': '56px' }"
          >
            <v-chip
              v-for="(category, index) in item.categories"
              :key="index"
              class="text-center mr-1 mb-1"
              small
              outlined
              @click="allGamesCategory(category)"
              style="cursor: pointer;"
            >
              {{ category }}
            </v-chip>
          </div>
          <!-- Description Game -->
          <v-card
            v-if="item.description_game"
            class="caption elevation-0"
            :class="isMobileBreakpoint ? 'pt-4 pb-12' : 'overflow-y-auto mt-2'"
            :style="{ order: isMobileBreakpoint ? 3 : 2 }"
          >
            {{ item.description_game }}
          </v-card>
          <v-spacer v-if="!isMobileBreakpoint" style="order: 3;" />
          <!-- Play button -->
          <div :style="{ order: isMobileBreakpoint ? 2 : 4 }">
            <!-- Buttons -->
            <div
              class="caption d-flex justify-space-between align-center"
              :class="{ 'flex-column': isMobileBreakpoint }"
              style="gap: 10px;"
            >
              <v-btn
                v-if="$store.state.logged.status"
                class="caption px-2 mt-4 casino-play-btn"
                :class="isMobileBreakpoint ? 'py-3 mb-n3' : 'py-5'"
                color="primary"
                outlined
                @click="handleGameFavorite(item)"
                style="width: 100%;"
              >
                <v-icon left size="24">{{ btnFavoriteConfig.icon }}</v-icon>
                {{ btnFavoriteConfig.text }}
              </v-btn>
              <v-btn
                v-if="item.hasDemo"
                class="caption px-2 mt-4 casino-play-btn"
                :class="isMobileBreakpoint ? 'py-3 mb-n3' : 'py-5'"
                color="primary"
                :disabled="!$store.state.logged.status"
                @click="gameClicked({ item, demo: false })"
                style="width: 100%;"
              >
                Demo
              </v-btn>
              <v-btn
                class="caption px-2 mt-4 casino-play-btn"
                :class="isMobileBreakpoint ? 'py-3 mb-6' : 'py-5'"
                color="primary"
                @click="gameClicked({ item, demo: false })"
                style="width: 100%;"
              >
                <v-icon left size="24">mdi-play</v-icon>
                {{ $t("play") }}
              </v-btn>
            </div>
            <!-- Text Login or Create Account -->
            <!-- <div
              v-if="!$store.state.logged.status"
              class="text-subtitle-2 mt-4 text-center"
            >
              {{ $t("newCasino.search.toPlayDo") }}

              <Login
                :isTextButton="true"
                :urlRedirect="getRedirectUrlGame({ item, demo: false })"
                @closeDialog="closeDialog"
              />

              {{ $t("particleOr").toLowerCase() }}

              <DialogRegister
                idDialog="itemDialog"
                :isTextButton="true"
                :urlRedirect="getRedirectUrlGame({ item, demo: false })"
                @closeDialog="closeDialog"
              />
            </div> -->
          </div>
        </div>
        <!-- <div class="pr-2">
            <v-icon size="24">
              mdi-star
            </v-icon>
          </div> -->
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
// import Login from "@/components/login/dialog.vue";
// import DialogRegister from "@/views/home/register/dialog-register";
import {
  isGameFavorite,
  addGameFavorite,
  removeGameFavorite
} from "@/util/casino/gameFavorite.js";

export default {
  name: "item-dialog",

  // components: { Login, DialogRegister },

  props: ["dialog", "item", "type", "categoryName"],

  data: () => ({
    imageError: false,
    btnFavoriteConfig: { icon: "", text: "" },
  }),

  mounted() {
    this.updateBtnFavoriteConfig();
  },

  watch: {
    dialog(state) {
      if (state) this.updateBtnFavoriteConfig();
    },
    gamesFavoritesUpdating() {
      this.updateBtnFavoriteConfig();
    },
  },

  computed: {
    backgroundGame() {
      const { identifier_game } = this.item;
      if (this.item && identifier_game) {
        return `url(https://cdn.softswiss.net/b/${
          identifier_game.split(":")[0]
        }/${identifier_game.split(":")[1]}.jpg)`;
      }
      return "";
    },
    volatilityText() {
      const volatility = this.item.volatility_rating;
      if (!volatility) return "";
      return this.$t(`newCasino.volatility.${volatility}`);
    },
    volatilityColor() {
      const map = {
        high: "red--text text--darken-2",
        "very-high": "red--text text--darken-2",
        "medium-high": "orange--text text--darken-2",
        medium: "yellow--text text--lighten-1",
        "low-medium": "green--text text--lighten-1",
        low: "green--text text--lighten-1",
      };
      return map[this.item.volatility_rating];
    },
    rtpValue() {
      return this.item.payout;
    },
    casinoType() {
      return this.$route.params.casinoType
        || (this.item.has_live_game == 0 ? "casino" : "live");
    },
    isMobileBreakpoint() {
      return this.$vuetify.breakpoint.mobile;
    },
    gamesFavoritesUpdating() {
      return this.$store.state.gamesFavoritesUpdating;
    },
  },

  methods: {
    gameClicked({ item }) {
    // gameClicked({ item, demo }) {
      this.closeDialog();

      // if (!this.$store.state.logged.status) {
      //   const itemWithRedirectUrl = this.getRedirectUrlGame({ item, demo });

      //   this.$root.$emit("openUnloggedDialog", itemWithRedirectUrl);
      //   return;
      // }

      const currentCasinoTypeGame = item.has_live_game == 0 ? "casino" : "live";

      if (this.type === "provider") {
        // const query = { demo: false };
        let query = {};

        if (this.$vuetify.breakpoint.mobile) {
          query.firstViewGame = true;
        }

        this.$router.push({
          name: "casinoGameProvider",
          params: {
            gameId: item.game_id,
            casinoType: currentCasinoTypeGame,
          },
          query,
        });
      } else if (
        this.type === "category" ||
        (this.type === "lobby" && this.categoryName)
      ) {
        let query = {
          // demo,
        };

        if (this.$vuetify.breakpoint.mobile) {
          query.firstViewGame = true;
        }

        this.$router.push({
          name: "casinoGameCategory",
          params: {
            gameId: item.game_id,
            casinoType: currentCasinoTypeGame,
            category: this.categoryName
              ? this.categoryName
              : this.$route.params.category,
          },
          query,
        });
      } else if (this.type === "favorites") {
        const query = { demo: false };

        if (this.$vuetify.breakpoint.mobile) {
          query.firstViewGame = true;
        }

        this.$router.push({
          name: "casinoGameFavorites",
          params: {
            gameId: item.game_id,
            casinoType: currentCasinoTypeGame,
          },
          query,
        });
      } else {
        // const query = { demo: false };
        let query = {};

        if (this.$vuetify.breakpoint.mobile) {
          query.firstViewGame = true;
        }

        this.$router.push({
          name: "casinoGame",
          params: {
            gameId: item.game_id,
            casinoType: currentCasinoTypeGame,
          },
          query,
        });
      }
    },
    updateBtnFavoriteConfig() {
      const btnConfig = {
        0: {
          icon: "mdi-star-outline",
          text: this.$tc("newCasino.btnFavorite", 0),
        },
        1: {
          icon: "mdi-star-check",
          text: this.$tc("newCasino.btnFavorite", 1),
        },
      };

      if (this.item && this.item.key) {
        this.btnFavoriteConfig =
          btnConfig[isGameFavorite(this.casinoType, this.item.key)];
      }
    },
    handleGameFavorite(game) {
      if (isGameFavorite(this.casinoType, game.key)) {
        removeGameFavorite(this.casinoType, game.key);
      } else {
        addGameFavorite(this.casinoType, game);
      }
    },
    allGamesCategory(category) {
      this.closeDialog();

      if (this.$route.params.category != category) {
        this.$router.push({
          name: "casinoCategory",
          params: { category },
        });
      }
    },
    allGamesProvider(providerId) {
      if (providerId === this.$route.params.providerId) return;

      this.$router.push({
        name: "casinoProvider",
        params: { providerId },
      });
    },
    getRedirectUrlGame({ item, demo }) {
      if (!item) {
        return "";
      }

      const currentCasinoTypeGame = item.has_live_game == 0 ? "casino" : "live";
      const gameRouteType = this.type === "provider" ? "providers" : "category";

      const value = item.categoryName
        ? item.categoryName
        : this.type === "provider"
        ? this.$route.params.providerId
        : this.categoryName
        ? this.categoryName
        : this.$route.params.category;

      let redirectUrl = `/casino/lobby/${currentCasinoTypeGame}/${gameRouteType}/${value}/game/${item.game_id}`;
      redirectUrl += `?demo=${!!demo}`;

      return redirectUrl;
    },
    closeDialog() {
      this.imageError = false;
      this.$emit("closeItemDialog");
    },
  },
};
</script>
<style>
@media (min-width: 600px) {
  .dialogStyle {
    border-radius: 27px;
  }
}

.item-info {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #d9d9d9;
}

.item-info-value {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
}

.item-description {
  display: -webkit-box;
  -webkit-line-clamp: 5;
  padding: 1rem 0;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.tooltip {
  width: 295px;
  background-color: rgb(87, 87, 87);
  color: #fff;
  text-align: left;
  border-radius: 6px;
  padding: 0.1rem 0;
}

.tooltip__content--rtp {
  background-color: rgb(87, 87, 87) !important;
  opacity: 1 !important;
}

.tooltip__content--rtp::after {
  left: 36px;
  border: 10px solid transparent;
  border-bottom-color: rgb(87, 87, 87) !important;
}

.tooltip__content--volatility {
  background-color: rgb(87, 87, 87) !important;
  opacity: 1 !important;
}

.tooltip__content--volatility::after {
  right: 128px;
  border: 10px solid transparent;
  border-bottom-color: rgb(87, 87, 87) !important;
}

.backgroundImageOverlay {
  position: relative;
  -webkit-transition: background 200ms ease-in-out 300ms;
  -moz-transition: background 200ms ease-in-out 300ms;
  -o-transition: background 200ms ease-in-out 300ms;
  transition: background 200ms ease-in-out 300ms;
}

.backgroundImageOverlay::before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
